import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { SubgroupImportModel } from './../../../../models/imports/subgroup-import.model';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-import-subgroup',
  templateUrl: './import-subgroup.component.html',
  styleUrls: ['./import-subgroup.component.scss'],
  standalone: false
})
export class ImportSubgroupComponent {

  subgroupImport: boolean = false;
  eventFile: any;
  errorSubGroup: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  subGroupAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  visibleTxt: boolean = false;

  constructor(
    private subgroupService: SubgroupService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attach() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  downloadGuideImport() {
    this.subgroupService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaSubgrupos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.subGroupAlerts || this.subGroupAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.subgroupService.exportImportErrors(this.subGroupAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionSubGrupos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  close() {
    const data: ModalObjectType = {};
    if (this.subgroupImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importSubgroups() {
    this.subGroupAlerts = [];
    this.errorSubGroup = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<SubgroupImportModel>();
      let row: SubgroupImportModel;
      let counter: number = 1, groupCode: string, code: string, name: string;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast(
              'error',
              'El archivo ingresado no tiene registros para importar.'
            );
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Grupo:
            groupCode = element[0] as string;
            if (groupCode == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código del grupo no es válido.`;
              this.subGroupAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código:
            code = element[1] as string;
            if (code == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código no es válido.`;
              this.subGroupAlerts.push(alert);
              rowHasError = true;
            } else if (code.length > 3) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El código supera el tamaño máximo de caracteres (3)`
              this.subGroupAlerts.push(alert);
              rowHasError = true;
            }

            //C. Nombre:
            name = element[2] as string;
            if (name == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El nombre no es válido.`
              this.subGroupAlerts.push(alert);
              rowHasError = true;
            } else if (name.length > 50) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. El nombre supera el tamaño máximo de caracteres (50).`
              this.subGroupAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new SubgroupImportModel(counter, groupCode, code, name);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.subgroupService.importSubgroups(rowsImports));
              this.loadPreInvoicingModel = response;
              this.subGroupAlerts = response?.alerts ?? [];
              this.errorSubGroup = response?.preInvoicingStateId;

              if (this.errorSubGroup === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR'
                );
              } else if (this.subGroupAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con alertas, puede exportarlas si lo desea'
                );
              } else {
                this.visibleTxt = false;
                this.subgroupImport = true;
                this.toastHandlerService.showToast(
                  'success',
                  `La importación terminó exitosamente.`
                );
                this.close();
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Subgrupos.', error);
            }
          } else {
            this.errorSubGroup = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast(
          'error',
          'No ha seleccionado ningún archivo.'
        );
      }
    }
  }
}
